import { getElement } from "./dom";
import { input } from "./formControls";
export function showLoginView(credentialStatus, onSaveCredentials) {
    getElement("app-menu").open = false;
    if (credentialStatus?.connected) {
        hideLoginView();
        getElement("status").textContent = `Connected to Odoo as ${credentialStatus.odooUser}.`;
        return;
    }
    renderLoginView(credentialStatus, onSaveCredentials);
    getElement("login-view").classList.remove("is-hidden");
}
export function hideLoginView() {
    getElement("login-view").classList.add("is-hidden");
}
export function renderLoginMenuItem(credentialStatus) {
    const loginButton = getElement("login-menu-item");
    const disconnectButton = getElement("disconnect-menu-item");
    const isConnected = Boolean(credentialStatus?.connected);
    loginButton.classList.toggle("is-hidden", isConnected);
    disconnectButton.classList.toggle("is-hidden", !isConnected);
    disconnectButton.textContent = credentialStatus?.odooUser ? `Disconnect ${credentialStatus.odooUser}` : "Disconnect";
}
export function renderLoginView(credentialStatus, onSaveCredentials) {
    if (credentialStatus?.connected) {
        hideLoginView();
        return;
    }
    getElement("login-view").innerHTML = `
    <h2>
      Odoo Login
      <button id="login-close-button" class="icon-button" type="button" aria-label="Close login">×</button>
    </h2>
    <p class="credential-status">Enter your personal Odoo user and API key.</p>
    <form id="credentials-form" class="form credential-form">
      ${input("Odoo user", "odooUser", credentialStatus?.odooUser)}
      ${input("Odoo API key", "odooApiToken", "", "password")}
      <div class="form-actions">
        <button id="credentials-save-button" type="submit">Save credentials</button>
      </div>
    </form>
  `;
    getElement("credentials-form").addEventListener("submit", (event) => {
        event.preventDefault();
        onSaveCredentials();
    });
    getElement("login-close-button").addEventListener("click", () => hideLoginView());
}
